class WageTemplateItem {
    id = 0;
    wage_template_id = null;
    rank_id = null;
    seniority = 1;
    full = 0;
    sick = 0;
    travel = 0;
    training = 0;
    quarantine = 0;
    standby = 0;
    other = 0;
    fixed = 0;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default WageTemplateItem;
